export default "__VITE_ASSET__VXn_h3_bOvNykhEjXYMbxA__"